class ApiHelper {
  /**
    * fetch api for post method.
    * @param url The request url.
    * @param data A data object.
    */
  static async Post(url, data) {
    const res = await fetch(url, {
      credentials: "include",
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });
    if (!res.ok) {
      const json = await res.json();
      console.log(json.message);
      throw new Error('Có lỗi xảy ra, vui lòng thử lại sau.');
    }
    return res;
  }

  /**
    * fetch api for post method return json().
    * @param url The request url.
    * @param data A data object.
    */
  static async PostJson(url, data) {
    const res = await fetch(url, {
      credentials: "include",
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });
    const json = await res.json();
    if (!res.ok) {
      console.log(json.message);
      throw new Error('Có lỗi xảy ra, vui lòng thử lại sau.');
    }
    else return json;
  }

  /**
    * fetch api for get method.
    * @param url The request url.
    * @param data A data object.
    */
  static async Get(url, data) {
    const params = data ? '?json=' + JSON.stringify(data) : '';
    const res = await fetch(url + params, {
      credentials: "include",
      method: 'GET',
      headers: {
        "Content-Type": "application/json"
      }
    });
    if (!res.ok) {
      const json = await res.json();
      console.log(json.message);
      throw new Error('Có lỗi xảy ra, vui lòng thử lại sau.');
    }
    return res;
  }

  /**
    * fetch api for get method return json().
    * @param url The request url.
    * @param data A data object.
    */
  static async GetJson(url, data) {
    const params = data ? '?json=' + JSON.stringify(data) : '';
    const res = await fetch(url + params, {
      credentials: "include",
      method: 'GET',
      headers: {
        "Content-Type": "application/json"
      }
    });
    const json = await res.json();
    if (!res.ok) {
      console.log(json.message);
      throw new Error('Có lỗi xảy ra, vui lòng thử lại sau.');
    }
    return json;
  }
}

export default ApiHelper;


// WEBPACK FOOTER //
// ./src/services/api-helper.jsx